export default __webpack_public_path__ + "static/media/bg.f5a11b74.png";